async function loadEvents() {
    const eventSections = document.querySelectorAll(".gh-upcoming-event[data-type]");

    if (!eventSections.length) {
        console.warn("No event sections found on the page.");
        return;
    }

    try {
        const response = await fetch("/ghost/api/content/posts/?key=85a161edb0b0a13fe0a5e18bcd&filter=tag:event");
        if (!response.ok) throw new Error(`Failed to fetch events: ${response.statusText}`);

        const { posts } = await response.json();
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Normalize to start of day for comparison

        const events = posts.map((post) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(post.html, "text/html");
            const eventDetails = doc.querySelector("#event-details");

            if (eventDetails) {
                try {
                    const eventData = JSON.parse(eventDetails.getAttribute("data-json"));
                    const eventDate = new Date(eventData.date);

                    // Only return events that are in the future or today
                    if (eventDate >= today) {
                        return {
                            ...eventData,
                            title: post.title,
                            link: post.url,
                            description: post.custom_excerpt || "No description available.",
                            dateObject: eventDate,
                        };
                    }
                } catch (err) {
                    console.error("Error parsing event JSON:", err, "Post title:", post.title);
                }
            }
            return null;
        }).filter(Boolean);

        eventSections.forEach((section) => {
            const type = section.dataset.type;
            const filteredEvents = events.filter(event => event.type === type);

            // Preserve the `gh-grid-header`
            const gridHeader = section.querySelector(".gh-grid-header");

            // Clear the section and re-append the header
            section.innerHTML = "";
            if (gridHeader) {
                section.appendChild(gridHeader);
            }

            if (!filteredEvents.length) {
                const emptyState = document.createElement("div");
                emptyState.className = "gh-event-empty";
                emptyState.innerHTML = `<p>No upcoming events for ${type.replace("-", " ")}.</p>`;
                section.appendChild(emptyState);
                return;
            }

            const eventFeedContainer = document.createElement("div");
            eventFeedContainer.className = "gh-event-feed gh-grid-content gh-grid-cols-3";

            filteredEvents.sort((a, b) => a.dateObject - b.dateObject);

            filteredEvents.forEach((eventData) => {
                const date = eventData.dateObject;
                const day = date.toLocaleDateString("en-GB", { day: "2-digit" });
                const month = date.toLocaleDateString("en-GB", { month: "short" });
                const year = date.toLocaleDateString("en-GB", { year: "numeric" });

                const eventCard = document.createElement("article");
                eventCard.className = "gh-event-card";
                eventCard.innerHTML = `
                    <a class="gh-event-card-link" href="${eventData.link}">
                        <div class="gh-event-card-header">
                            <div class="gh-event-card-date">
                                <span class="gh-event-card-day">${day}</span>
                                <div class="gh-event-card-month-year">
                                    <span class="gh-event-card-month">${month}</span>
                                    <span class="gh-event-card-year">${year}</span>
                                </div>
                            </div>
                            <div class="gh-event-card-type-time">
                                <span>${eventData.location || "Online"}</span>
                                <span>${eventData.start_time} - ${eventData.end_time} (SAST)</span>
                            </div>
                        </div>
                        <hr class="gh-event-card-divider">
                        <div class="gh-event-card-body">
                            <h3 class="gh-event-card-title">${eventData.title}</h3>
                            <p class="gh-event-card-description">${eventData.description}</p>
                        </div>
                    </a>
                `;
                eventFeedContainer.appendChild(eventCard);
            });

            section.appendChild(eventFeedContainer);
        });

    } catch (error) {
        console.error("Error loading events:", error);
    }
}

export default loadEvents;